import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from './hoc/Layout/Layout';
import Login from './containers/Login/LoginContainer';
import ForgetPassword from './containers/Login/ForgetPassword';
import GeneratePassword from './containers/Login/GeneratePassword';
import Userlayout from './containers/User/UserLayout';
import Channels from './containers/Channels';
import Developer from './Developers/developers';
import WhatsAppTemplate from './containers/Channels/WhatsApp';
import SmsTemplate from './containers/Channels/Sms';
import Email from './containers/Channels/Email';
import CampaignTab from './Campaign';
import Templates from './containers/Channels/Templates';
import CampaignTable from './Campaign/Table';
import BroadCast from './Campaign/BroadCast';
import './style/weTheme/index.less';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/forget-password" component={ForgetPassword} />
      <Route
        exact
        path="/GeneratePassword/:token"
        component={GeneratePassword}
      />
      <Route
        path="/user"
        render={({ match: { url } }) => (
          <>
            <RouteWrapper
              exact
              path={`${url}/`}
              component={Userlayout}
              layout={Layout}
            />
          </>
        )}
      />
      <Route
        path="/channels"
        render={({ match: { url } }) => (
          <>
            <RouteWrapper
              exact
              path={`${url}/`}
              component={Channels}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/whatsapp`}
              component={WhatsAppTemplate}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/sms`}
              component={SmsTemplate}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/email`}
              component={Email}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/Templates`}
              component={Templates}
              layout={Layout}
            />
          </>
        )}
      />
      <Route
        path="/developer"
        render={({ match: { url } }) => (
          <>
            <RouteWrapper
              exact
              path={`${url}/`}
              component={Developer}
              layout={Layout}
            />
          </>
        )}
      />
      <Route
        path="/campaign"
        render={({ match: { url } }) => (
          <>
            <RouteWrapper
              exact
              path={`${url}/create-new`}
              component={CampaignTab}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/all-campaigns`}
              component={CampaignTable}
              layout={Layout}
            />
            <RouteWrapper
              exact
              path={`${url}/all-broadCast`}
              component={BroadCast}
              layout={Layout}
            />
          </>
        )}
      />
    </Switch>
  );
}

function RouteWrapper({ component: Component, layout: Layout, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}
export default App;
